import { JSX } from 'react'

import { IconProps } from '../../icon'

const Videos: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M32.2024 8H15.794C11.495 8 8 11.495 8 15.794V25.639C8 29.938 11.495 33.433 15.794 33.433H17.0903L14.6946 38.2079C14.3829 38.815 14.629 39.5533 15.2525 39.8651C15.876 40.1769 16.598 39.9307 16.9098 39.3072L19.8469 33.4166H28.1659L31.103 39.3072C31.3163 39.7338 31.7594 39.98 32.2024 39.98C32.3829 39.98 32.5798 39.9307 32.7439 39.8487C33.351 39.5369 33.5971 38.7986 33.3017 38.1914L30.9061 33.4166H32.2024C36.5014 33.4166 39.9964 29.9216 39.9964 25.6226V15.794C39.9964 11.495 36.5014 8 32.2024 8ZM37.5351 25.639C37.5351 28.5761 35.1395 30.9718 32.2024 30.9718H15.794C12.8569 30.9718 10.4613 28.5761 10.4613 25.639V15.794C10.4613 12.8569 12.8569 10.4613 15.794 10.4613H32.2024C35.1395 10.4613 37.5351 12.8569 37.5351 15.794V25.639Z'
      fill='black'
    />
    <path
      d='M29.1996 18.3209L23.949 14.8259C23.0629 14.2352 21.9307 14.186 20.9954 14.6782C20.0602 15.1869 19.4859 16.155 19.4859 17.2051V24.1951C19.4859 25.2616 20.0602 26.2297 20.9954 26.722C21.4221 26.9517 21.8815 27.0666 22.3573 27.0666C22.9152 27.0666 23.4731 26.9025 23.949 26.5907L29.1996 23.0957C30.0037 22.5542 30.4795 21.6682 30.4795 20.7001C30.4795 19.732 30.0037 18.8459 29.1996 18.3045V18.3209ZM27.8377 21.0447L22.5871 24.5397C22.4066 24.6545 22.2425 24.6053 22.1604 24.5561C22.0784 24.5068 21.9471 24.4084 21.9471 24.1951V17.2215C21.9471 17.0082 22.0784 16.9098 22.1604 16.8605C22.2097 16.8441 22.2753 16.8113 22.3573 16.8113C22.423 16.8113 22.505 16.8277 22.5871 16.8769L27.8377 20.3719C28.0018 20.4704 28.0182 20.6345 28.0182 20.7165C28.0182 20.7985 28.0018 20.9462 27.8377 21.0611V21.0447Z'
      fill='black'
    />
  </svg>
)

export default Videos
